<div class="ui-g-12">
  <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/promotion/catalog" label="{{ 'common.back' | translate }}"></button>
  <app-kontable
    #table
    title="{{ 'catalog.giftListTitle' | translate: {catalogName: catalogName} }}"
    [columns]="[
      {field: 'id', title: 'ID'},
      {field: 'category_gift_desc', title: 'promo.categoryGiftId', filterType: customFilter, filterTemplate: categoryGiftFilter},
      {field: 'brand', title: 'brandList.brand'},
      {field: 'itm_code_host', title: 'catalog.itmCodeHost'},
      {field: 'itm_code', title: 'catalog.itemCode'},
      {field: 'description', title: 'catalog.description'},
      {field: 'img_url', title: 'catalog.imageUrl'},
      {field: 'flg_reserved', title: 'catalog.reservable', bodyTemplate: flgReservedBT, filterType: customFilter, filterTemplate: flgReservedFilter},
      {field: 'type_gift_desc', title: 'catalog.giftType', filterType: customFilter, filterTemplate: giftTypeFilter},
      {field: 'reservation_type_desc', title: 'catalog.reservationType', filterType: customFilter, filterTemplate: reservationTypeFilter},
      {field: 'delivery_type_desc', title: 'catalog.deliveryType', filterType: customFilter, filterTemplate: deliveryTypeFilter}
    ]"
    [service]="catalogGiftService"
    [paginationType]="paginationType"
    (onEdit)="editGift($event.id)"
    (onAdd)="addGift()"
    (onRemove)="deleteCatalogGift($event.id, table)"
    (onRecover)="recoverCatalogGift($event)"
    [showRecoverButton]="true"
    [showInfoButton]="false"
    [showAddButton]="true"
    [showDeleteButton]="true"
    [showDetailsButton]="false"
    [showEditButton]="true"
    [showReport]="true"
    [(fireNewDataAvailable)]="newDataAvailable"

  >
    <!-- Filtro Categoria Premio -->
    <ng-template #categoryGiftFilter data-testid="categoryGiftFilter" let-col>
      <p-dropdown [options]="categoryGiftDesc" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search[col.field]" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
    </ng-template>
    <!-- Filtro Tipologia Premio -->
    <ng-template #giftTypeFilter data-testid="giftTypeFilter" let-col>
      <p-dropdown [options]="giftTypes" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search[col.field]" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
    </ng-template>
    <!-- Filtro Tipo Prenotazione -->
    <ng-template #reservationTypeFilter data-testid="reservationTypeFilter" let-col>
      <p-dropdown [options]="reservationTypes" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search[col.field]" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
    </ng-template>
    <!-- Filtro Tipo Consegna -->
    <ng-template #deliveryTypeFilter data-testid="deliveryTypeFilter" let-col>
      <p-dropdown [options]="deliveryTypes" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search['delivery_type_desc']" (onChange)="table.updateTableFilter('delivery_type_desc', $event.value, 'equals')"></p-dropdown>
    </ng-template>

    <!-- Template Flag Prenotabile -->
    <ng-template #flgReservedFilter data-testid="flgReservedFilter" let-col>
      <p-dropdown [options]="flgReserved" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search[col.field]" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
    </ng-template>
    <!-- Template Flag Prenotabile-->
    <ng-template #flgReservedBT data-testid="flgReservedBT" let-row>
      <span *ngIf="row.flg_reserved == 0">Si</span>
      <span *ngIf="row.flg_reserved == 1">No</span>
    </ng-template>
  </app-kontable>
</div>



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog/catalog-gift/catalog-gift.component.html